import createIcon from '../../createIcon';

/**
 * @component @name NextPlan
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xOCAxMy45N0gxM0wxNS4yNiAxMS43MUMxNC4zNSAxMC42NSAxMy4wMSA5Ljk3IDExLjUgOS45N0M5LjEzIDkuOTcgNy4xNSAxMS42MyA2LjY0IDEzLjg1TDUuNjggMTMuNTNDNi4zMiAxMC45MSA4LjY4IDguOTcgMTEuNSA4Ljk3QzEzLjI4IDguOTcgMTQuODcgOS43NiAxNS45NyAxMUwxOCA4Ljk3VjEzLjk3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NextPlan = createIcon('NextPlan', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM18 13.97H13L15.26 11.71C14.35 10.65 13.01 9.97 11.5 9.97C9.13 9.97 7.15 11.63 6.64 13.85L5.68 13.53C6.32 10.91 8.68 8.97 11.5 8.97C13.28 8.97 14.87 9.76 15.97 11L18 8.97V13.97Z',
      key: '1ozcx4',
    },
  ],
]);

export default NextPlan;
